export default "__VITE_ASSET__GA6sD2bm__"